import { render, staticRenderFns } from "./simple-footer.vue?vue&type=template&id=ae1b2c9a&scoped=true&"
import script from "./simple-footer.vue?vue&type=script&lang=js&"
export * from "./simple-footer.vue?vue&type=script&lang=js&"
import style0 from "./simple-footer.vue?vue&type=style&index=0&id=ae1b2c9a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae1b2c9a",
  null
  
)

export default component.exports